import { StyleSheet } from 'aphrodite';
import { destructive } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		fontSize: 14,
		...CssSelectors.allDescendants(
			{
				backgroundColor: 'rgb(173, 226, 173)',
				height: '100%',
				width: '100%',
			},
			'.dragging-over'
		),
	},
	dragInstructions: {
		margin: '10px 20px 20px 0px',
		maxWidth: 500,
	},
	header: {},
	row: {
		alignItems: 'center',
		display: 'flex',
		paddingTop: 10,
	},
	rowLabel: {},
	rowValue: {
		marginLeft: 20,
	},
	upload: {
		backgroundColor: '#f3f3f3',
		height: 300,
	},
	uploadTarget: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
	warning: {
		color: destructive,
	},
});
